import { hasUrlParam } from 'utility/Provide/Url';

export const removeCsCodeFromUrl = () => {
    const hasCsCode = hasUrlParam('cs_code');
    if (hasCsCode) {
        const url = new URL(window.location.href);
        url.searchParams.delete('cs_code');
        window.history.replaceState({}, '', url.toString());
    }
};
